export default {
  singularNotClassified: 'No clasificado',
  pluralNotClassified: 'No clasificados',
  showNotClassified: 'Mostrar no clasificados',
  showClassified: 'Ocultar no clasificados',
};
